import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";
import AdviserPage from "../pages/AdvisorPage";
import AssistantPage from "../pages/AssistantPage";
import ClientPage from "../pages/ClientPage";
import OwnerPage from "../pages/OwnerPage";
import SaasPlansPage from "../pages/SaasPlansPage";
import AzureMarketplacePage from "../pages/AzureMarketplacePage";
import RegisterLeadPage from "../pages/RegisterLeadPage";
import QualifyingQuestionsPage from "../pages/QualifyingQuestionsPage";
import ConsultationBookingPage from "../pages/ConsultationBookingPage";
import { UserRole } from "../types/auth.types";


const RoleRoute = ({
  role,
  children,
}: {
  role: UserRole;
  children: React.ReactNode;
}) => {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to="/login" replace />;

  return <>{children}</>;
};

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* <Route path="/signup" element={<SignupPage />} /> */}
      <Route path="/register-lead" element={<RegisterLeadPage />} />
      <Route path="/qualifying-questions" element={<QualifyingQuestionsPage />} />
      <Route path="/consultation-booking" element={<ConsultationBookingPage />} />
      {/* <Route path="/marketplace/azure" element={<AzureMarketplacePage />} /> */}

      <Route
        path="/adviser"
        element={
          <RoleRoute role="ADVISER">
            <AdviserPage />
          </RoleRoute>
        }
      />

      <Route
        path="/assistant"
        element={
          <RoleRoute role="ASSISTANT">
            <AssistantPage />
          </RoleRoute>
        }
      />

      <Route path="/admin" element={<Navigate to="/owner" replace />} />

      <Route
        path="/client"
        element={
          <RoleRoute role="CLIENT">
            <ClientPage />
          </RoleRoute>
        }
      />

      <Route
        path="/owner"
        element={
          <RoleRoute role="OWNER">
            <OwnerPage />
          </RoleRoute>
        }
      />
      <Route
        path="/owner/saas-plans"
        element={
          <RoleRoute role="OWNER">
            <SaasPlansPage />
          </RoleRoute>
        }
      />

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
};
